// Guard de autenticación — verifica que existe un token válido
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../../core/infrastructure/services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Si el token es válido, permitir acceso
  if (authService.isTokenValid()) {
    return true;
  }

  // Si no hay token, intentar obtener uno
  return authService.fetchToken().pipe(
    map(() => true),
    catchError(() => {
      // Si falla la obtención del token, redirigir al inicio
      // TODO: definir ruta de error/login según flujo de negocio
      router.navigate(['/']);
      return of(false);
    }),
  );
};
